import React from 'react'
import { withTheme, createComponent } from '@ycos/fela'
import { getFontStyles } from '@ycos/primitives'
import { array, shape, number, bool, string } from 'prop-types'
import DesktopLayout from './desktop/DesktopCarousel'
import MobileLayout from './mobile/MobileLayout'

const RewardsCarouselOuter = createComponent('RewardsCarouselOuter', () => ({
  width: '100%'
}))

const RewardsCarouselTitle = createComponent(
  'RewardsCarouselTitle',
  ({ theme }) => {
    const { type, name, fontSize, lineHeight, fontWeight, fontSizeMedium, lineHeightMedium, paddingBottomMedium } = theme.custom.loyaltyRewardsCarousel.title
    return {
      ...getFontStyles(theme.typography, {
        type,
        tagName: 'h3',
        name
      }),
      padding: `0 0 ${theme.spacingMultiplier * 3}px`,
      textAlign: 'center',
      fontSize,
      lineHeight,
      fontWeight,
      color: theme.typography.colors.PrimaryBlack,
      'screen-large': {
        fontSize: fontSizeMedium,
        lineHeight: lineHeightMedium,
        paddingBottom: paddingBottomMedium || `${theme.spacingMultiplier * 3}px`
      }
    }
  },
  'div'
)

const MobileRewardsCarousel = createComponent('MobileRewardsCarousel', () => ({
  'screen-large': {
    display: 'none'
  }
}))

const DesktopRewardsCarousel = createComponent('DesktopRewardsCarousel', () => ({
  display: 'none',
  'screen-large': {
    display: 'block'
  }
}))

const RewardsCarousel = ({ item, config, lazy, brand }) => {
  const { imageSphere } = config
  return (
    <>
      <RewardsCarouselOuter data-cm-metadata={item?.dataCmMetadata} data-testid="rewards-carousel-outer">
        {item.teaserTitle && <RewardsCarouselTitle data-testid="rewards-carousel-title">{item.teaserTitle}</RewardsCarouselTitle>}
        <MobileRewardsCarousel data-testid="rewards-carousel-mobile">
          <MobileLayout items={item.items} lazy={lazy} imageSphere={imageSphere} brand={brand}/>
        </MobileRewardsCarousel>
        <DesktopRewardsCarousel data-testid="rewards-carousel-desktop">
          <DesktopLayout items={item.items} lazy={lazy} imageSphere={imageSphere} />
        </DesktopRewardsCarousel>
      </RewardsCarouselOuter>
    </>
  )
}

RewardsCarousel.layoutVariant = ['isc-rewards-carousel']

RewardsCarousel.propTypes = {
  item: shape({
    teaserTitle: string,
    items: array
  }),
  config: shape({
    imageSphere: shape({
      quality: number,
      wZero: bool,
      nonTransformableUrls: array
    })
  })
}

RewardsCarousel.defaultProps = {
  item: {
    teaserTitle: '',
    items: []
  },
  config: {
    imageSphere: {
      quality: 80,
      wZero: false,
      nonTransformableUrls: [
        '.svg',
        '.gif',
        'cache.net-a-porter.com/images/products',
        'cache.mrporter.com/variants/images',
        'iris-integ.dev.product.ext.net-a-porter.com/mrp'
      ]
    }
  }
}

export default withTheme(RewardsCarousel)
